import { useEffect, useRef } from 'react';
import { useQuery, useQueryClient } from '@tanstack/react-query';
import { apiMethods } from '@/services/api';
import socketService from '@/services/socket';

export const CONNECTIONS_KEY = ['connections'];
export const UNREAD_KEY = ['connections', 'unread'];
export const LIST_KEY = ['connections', 'list'];

// Unread "shared their contact" count for the nav badge and dashboard tile.
export function useUnreadConnections() {
    return useQuery({
        queryKey: UNREAD_KEY,
        queryFn: async () => (await apiMethods.users.getConnections({ page: 1, limit: 1 })).data.unreadCount || 0,
        staleTime: 30 * 1000,
        refetchInterval: 2 * 60 * 1000,
        refetchOnWindowFocus: true,
    });
}

// Keeps the shared socket connected for the logged-in user and refreshes connection data when
// someone shares their contact. `onExchange` is optional (e.g. to show a toast).
export function useContactExchangeLive(userId, onExchange) {
    const queryClient = useQueryClient();
    const cb = useRef(onExchange);
    cb.current = onExchange;

    useEffect(() => {
        if (!userId) return undefined;
        socketService.connect(userId, 'user');
        const handle = (data) => {
            queryClient.invalidateQueries({ queryKey: CONNECTIONS_KEY });
            cb.current?.(data);
        };
        socketService.on('contactExchange', handle);
        return () => socketService.off('contactExchange', handle);
    }, [userId, queryClient]);
}
